import React, { Fragment, useEffect, useState } from "react";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Grid from "@material-ui/core/Grid";
import { read } from "Helpers/LocalStorage";
import PaymentService from "Services/http/endpoints/payment/PaymentService";
import StatusHandler from "Helpers/StatusHandler";
import { Typography } from "@material-ui/core";
import PageTitle from "Components/PageTitle/PageTitle";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import { push } from "Helpers/History";
import { useTranslation } from "react-i18next";

function InformationPanel() {
  const { t } = useTranslation();
  const [dataTime, setDataTime] = useState([]);
  const [loading, setLoading] = useState(false);

  const onShowService = () => {
    if (dataTime.Show === "Extension") {
      push("/dashboard/payment/extension-period");
    }
    if (dataTime.Show === "Sale") {
      push("/dashboard/payment");
    }
    if (dataTime.Show === "Upgrade") {
      push("/dashboard/payment/user-increase");
    }
  };
  const onShowWallet = () => {
    push("/dashboard/payment/wallet");
  };

  const onShowHistory = () => {
    push("/dashboard/payment/histories");
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        const response = await PaymentService.GetRemainTime(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const remainTime = response.data.Value;
          // console.log(remainTime);
          setDataTime(remainTime);
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <PageTitle
        className="mt-4"
        title={<Translator id={"panel_information"} />}
      />
      <Grid container className="mt-4" spacing={2}>
        <Grid item xs={12}>
          <p>
            {`${t("expiryCreditDate")} : `}
            <strong className="mx-2">{dataTime.JalaliDate}</strong>
          </p>
        </Grid>
        <Grid item xs={12}>
          <p>
            {`${t("walletBalance")} (${t("moneyUnit")}) : `}
            <strong className="mx-2">
              {dataTime.Credit?.toLocaleString()}
            </strong>
          </p>
        </Grid>
        <Grid item xs={12}>
          <p>
            {`${t("periodName")} : `}
            <strong className="mx-2">{dataTime.Period}</strong>
          </p>
        </Grid>
        <Grid item xs={12}>
          <p>
            {`${t("activeUsers")} : `}
            <strong className="mx-2">{dataTime.CountUser}</strong>
          </p>
        </Grid>

        {dataTime.RemaingTime && (
          <Grid container className="dataTimeRemaingTime">
            <Typography variant={"body2"} align="left">
              <p className="m-0">{`${t("RemainingTime")} :`}</p>
            </Typography>
            <div className="remaing-time">
              {dataTime.RemaingTime.Years.toString() !== "0" && (
                <div>
                  <strong style={{ fontSize: "16px" }}>
                    {dataTime.RemaingTime.Years}
                  </strong>
                  <p className="m-0">{t("info_Years")}</p>
                </div>
              )}
              {dataTime.RemaingTime.Months.toString() !== "0" && (
                <div>
                  <strong style={{ fontSize: "16px" }}>
                    {dataTime.RemaingTime.Months}
                  </strong>
                  <p className="m-0">{t("month")}</p>
                </div>
              )}
              {dataTime.RemaingTime.Days.toString() !== "0" && (
                <div>
                  <strong style={{ fontSize: "16px" }}>
                    {dataTime.RemaingTime.Days}
                  </strong>
                  <p className="m-0">{t("day")}</p>
                </div>
              )}
              {dataTime.RemaingTime.Hours.toString() !== "0" && (
                <div>
                  <strong style={{ fontSize: "16px" }}>
                    {dataTime.RemaingTime.Hours}
                  </strong>
                  <p className="m-0">{t("hour")}</p>
                </div>
              )}
              {dataTime.RemaingTime.Minutes.toString() !== "0" && (
                <div>
                  <strong style={{ fontSize: "16px" }}>
                    {dataTime.RemaingTime.Minutes}
                  </strong>
                  <p className="m-0">{t("minute")}</p>
                </div>
              )}
            </div>
          </Grid>
        )}
      </Grid>
      <Grid container spacing={2} className="mt-3 d-flex flex-row g-2 px-2">
        <MuiButton
          color="secondary"
          type="submit"
          title={t("purchase_form")}
          onClick={onShowService}
          disabled={dataTime.Show !== "Sale"}
          fullwidthOnSm
        />
        <MuiButton
          color="secondary"
          type="submit"
          title={t("form_add_user")}
          onClick={onShowService}
          disabled={dataTime.Show !== "Upgrade"}
          fullwidthOnSm
        />
        <MuiButton
          color="secondary"
          type="submit"
          title={t("current_term_renewal_form")}
          onClick={onShowService}
          disabled={dataTime.Show !== "Extension"}
          fullwidthOnSm
        />
        <MuiButton
          color="secondary"
          type="submit"
          title={t("history")}
          onClick={onShowHistory}
          fullwidthOnSm
        />
        <MuiButton
          color="secondary"
          type="submit"
          title={t("wallet")}
          onClick={onShowWallet}
          fullwidthOnSm
        />
      </Grid>
    </Fragment>
  );
}

export default InformationPanel;
